<template>
  <div class="card">
    <div class="card-header pb-0">
      <h6 class="mb-0">
        <font-awesome-icon icon="user-plus" class="me-2" />
        Crear Nuevo Usuario
      </h6>
      <p class="text-sm text-muted mb-0 mt-1">Registra un nuevo usuario en la plataforma</p>
    </div>
    <div class="card-body px-4">
      <form @submit.prevent="create">
        <div class="row">
          <!-- Columna 1 -->
          <div class="col-md-6 mb-3">
            <div class="mb-3">
              <label for="name" class="form-label">Nombre Completo</label>
              <input 
                id="name"
                type="text" 
                class="form-control" 
                v-model="form.name" 
                placeholder="Ingrese el nombre completo"
                required
              >
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Correo Electrónico</label>
              <input 
                id="email"
                type="email" 
                class="form-control" 
                v-model="form.email" 
                placeholder="ejemplo@mail.com"
                required
              >
            </div>
          </div>
          
          <!-- Columna 2 -->
          <div class="col-md-6 mb-3">
            <div class="mb-3">
              <label for="password" class="form-label">Contraseña</label>
              <input 
                id="password"
                type="password" 
                class="form-control" 
                v-model="form.password" 
                placeholder="Mínimo 6 caracteres"
                required
                minlength="6"
              >
              <div class="form-text text-xs">La contraseña debe tener al menos 6 caracteres</div>
            </div>
            <div class="mb-3">
              <label for="role" class="form-label">Rol</label>
              <select id="role" class="form-select" v-model="form.type" required>
                <option value="">Seleccione un rol</option>
                <option value="agent">Agente</option>
                <option value="administrator">Administrador del Sistema</option>
              </select>
            </div>
          </div>
        </div>

        <hr class="my-4">
        
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-outline-secondary me-2" @click="$router.back()">
            <font-awesome-icon icon="times" class="me-1" />
            Cancelar
          </button>
          <button type="submit" class="btn bg-gradient-success" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            <font-awesome-icon v-else icon="check" class="me-1" />
            {{ loading ? 'Creando...' : 'Crear Usuario' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { post } from "@/utils/httpRequest";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faUserPlus, faTimes, faCheck, faKey } from '@fortawesome/free-solid-svg-icons';

library.add(faUserPlus, faTimes, faCheck, faKey);

export default {
  name: "UserCreate",
  data: () => ({
    loading: false,
    form: {
      name: '',
      email: '',
      percentage: 0,
      password: '',
      type: '',
    }
  }),
  methods: {
    async create() {
      // Validación básica
      if (!this.form.name || !this.form.email || !this.form.type || !this.form.password) {
        this.$swal({
          title: 'Campos incompletos',
          text: 'Por favor, completa todos los campos requeridos.',
          icon: 'warning',
          confirmButtonColor: '#ea0606'
        });
        return;
      }

      // Validación de email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.form.email)) {
        this.$swal({
          title: 'Email inválido',
          text: 'Por favor, ingresa un correo electrónico válido.',
          icon: 'warning',
          confirmButtonColor: '#ea0606'
        });
        return;
      }

      if (this.form.password.length < 6) {
        this.$swal({
          title: 'Contraseña débil',
          text: 'La contraseña debe tener al menos 6 caracteres.',
          icon: 'warning',
          confirmButtonColor: '#ea0606'
        });
        return;
      }

      this.loading = true;

      try {
        const payload = {
          name: this.form.name.trim(),
          email: this.form.email.trim(),
          password: this.form.password,
          type: this.form.type,
          percentage: 0
        };
        
        const { data } = await post('users/create', payload);
        
        if (data === 200) {
          await this.$swal({
            title: '¡Usuario Creado!',
            html: `El usuario <strong>${payload.name}</strong> ha sido creado exitosamente.`,
            icon: 'success',
            timer: 2500,
            showCancelButton: false,
            showConfirmButton: false,
          });
          this.$router.push('/users');
        } else {
          throw new Error('Error inesperado al crear usuario');
        }
      } catch (err) {
        console.error('Error creating user:', err);
        
        let errorMessage = 'No se pudo crear el usuario. Por favor, intenta nuevamente.';
        
        if (err.response && err.response.status === 409) {
          errorMessage = 'Ya existe un usuario con este correo electrónico.';
        } else if (err.response && err.response.status === 400) {
          errorMessage = 'Datos inválidos. Por favor, verifica la información ingresada.';
        }

        this.$swal({
          title: 'Error',
          text: errorMessage,
          icon: 'error',
          confirmButtonColor: '#ea0606'
        });
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>
<style scoped lang="scss">
@media (max-width: 767px) {
  .margin_top_mobile {
    margin-top: 1.5rem !important;
  }
}
</style>
